




























































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
import InstitutionFeaturesEdit from '@/components/Settings/Institutions/Features/InstitutionFeaturesEdit.vue';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'InstitutionFeatures', components: { InstitutionFeaturesEdit } })
export default class extends SaascadaVue {

    FeatureToggleCode = FeatureToggleCode;

    get featureToggles() {
        return AuthModule.me.institution.config.featureToggles;
    }

}
